import React from 'react';
import DetailsModelTableWrapper from '../details-model-table-wrapper';
import DetailsModelTableRow from '../details-model-table-row';
import CalcBreakdownRows from './details-model-calc-breakdown';
import rowColors from './utils/details-model-colors';

const { rowColor1, rowColor2, rowColor3 } = rowColors;

const ContingencyDetailsModalTable = ({
  type,
  calcBreakDown,
  tableData,
  multiplyOn,
  formData,
  hideDetails,
}) => {
  const { markupDetails, contingencyDetails } = tableData;

  // Markup
  const { markupCost, totalAfterMarkup, totalMarkupPercentage } = markupDetails;

  // Contingency
  const {
    breakdownValues,
    contingencyPercentages,
    contingencyCost,
    totalAfterContingency,
    totalContingencyPercentage,
  } = contingencyDetails;

  const selectedKeys = Object.entries(multiplyOn)
    .filter(([key, value]) => formData[key] && value === true)
    .map(([key]) => key.charAt(0).toUpperCase() + key.slice(1).toLowerCase());

  return (
    <DetailsModelTableWrapper
      type={type}
      subtotal={totalAfterContingency[5].toFixed(2)}
      TotalCost={contingencyCost[5].toFixed(2)}
      tableData={tableData}
      hideDetails={hideDetails}
    >
      {[
        {
          title: 'Markup Cost',
          values: markupCost.map((item) => `$${item.toFixed(2)}`),
        },
        {
          title: 'Markup Percentage',
          values: totalMarkupPercentage.map((item) => `${item.toFixed(2)}%`),
        },
        {
          title: 'Cost With Markup',
          values: totalAfterMarkup.map((item) => `$${item.toFixed(2)}`),
          bgColor: rowColor3,
        },
        {
          title: `Contingency Cost ${
            selectedKeys.length > 0 ? `(Including ${selectedKeys.join(', ')} Cost)` : ''
          }`,
          values: contingencyCost.map((item) => `$${item.toFixed(2)}`),
        },
        {
          title: 'Contingency Percentage',
          values: contingencyPercentages.map((item) => `${item.toFixed(2)}%`),
        },
        {
          title: 'Total Cost With Markup & Contingency',
          values: totalAfterContingency.map((item) => `$${item.toFixed(2)}`),
          boldValues: true,
        },
        {
          title: 'Total Percentage With Markup & Contingency',
          values: totalContingencyPercentage.map((item) => `${item.toFixed(2)}%`),
          bgColor: rowColor1,
        },
      ].map((row, index) => (
        <DetailsModelTableRow
          key={index}
          title={row.title}
          description={row?.description || ''}
          values={row.values}
          bgColor={row?.bgColor || ''}
          boldValues={row?.boldValues || false}
          hideDetails={hideDetails}
        />
      ))}

      {calcBreakDown && (
        <CalcBreakdownRows
          breakdownValues={breakdownValues}
          title={`Total ${type} Cost`}
          costs={contingencyCost}
          hideDetails={hideDetails}
        />
      )}
    </DetailsModelTableWrapper>
  );
};

export default ContingencyDetailsModalTable;
